import * as Sentry from '@sentry/browser';
import 'flowbite';
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "gist-syntax-themes/stylesheets/tomorrow-night.css";
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import 'prismjs';

if (import.meta.env.PROD) {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_CRAFT_ENVIRONMENT
    });
}

Fancybox.bind("[data-fancybox]");
window.addEventListener('CookiebotOnDialogDisplay', function (e) {
    // Set aria-label on close buttons
    document.querySelectorAll('.CybotCookiebotBannerCloseButton').forEach(element => {
        element.setAttribute('aria-label', 'Close');
    });

    // Remove invalid form elements
    document.querySelectorAll('.CybotCookiebotDialogBodyLevelButtonSliderWrapper').forEach(element => {
        element.remove();
    });

    // Remove bottom wrapper with invalid form elements
    const cookiebotBottomWrapper = document.querySelector('.CybotCookiebotDialogBodyBottomWrapper');

    if (cookiebotBottomWrapper) {
        cookiebotBottomWrapper.remove();
    }

}, false);

window.addEventListener('load', () => {
    const hiddenIframes = document.querySelectorAll('iframe[style*="visibility: hidden"]');
    hiddenIframes.forEach((iframe) => {
        iframe.setAttribute('aria-hidden', 'true');
        iframe.setAttribute('tabindex', '-1');
    });
});

const themeToggleBtn = document.getElementById('theme-toggle');
const darkIcon = document.getElementById('theme-toggle-dark-icon');
const lightIcon = document.getElementById('theme-toggle-light-icon');

if (themeToggleBtn) {

    const isDarkPreferred = () =>
        localStorage.getItem('color-theme') === 'dark' ||
        (!localStorage.getItem('color-theme') && window.matchMedia('(prefers-color-scheme: dark)').matches);

    // Theme button icon
    (darkIcon.classList.toggle('hidden', isDarkPreferred()));
    (lightIcon.classList.toggle('hidden', !isDarkPreferred()));

    themeToggleBtn.addEventListener('click', function() {
        const isDark = document.documentElement.classList.toggle('dark');
        localStorage.setItem('color-theme', isDark ? 'dark' : 'light');
        darkIcon.classList.toggle('hidden');
        lightIcon.classList.toggle('hidden');

        // Reload Disqus for light/dark theme update
        if (typeof DISQUS !== "undefined") {
            DISQUS.reset({
                reload: true
            });
        }

        var storedTheme = localStorage.getItem('color-theme') || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");

        setTimeout(function() {
            var targetTheme = storedTheme == "dark" ? "light" : "dark";
            switchTweetTheme(targetTheme, storedTheme);
        }, 1000);
    });
}

function switchTweetTheme(currentTheme, targetTheme) {
    var tweets = document.querySelectorAll('[data-tweet-id]');

    tweets.forEach(function(tweet) {
        var src = tweet.getAttribute("src");
        tweet.setAttribute("src", src.replace("theme=" + currentTheme, "theme=" + targetTheme));
    });
}
